export const ATT_LOAD_LIST_REQUEST = 'ATT_LOAD_LIST_REQUEST';
export const ATT_LOAD_LIST_SUCCESS = 'ATT_LOAD_LIST_SUCCESS';
export const ATT_LOAD_LIST_FAIL = 'ATT_LOAD_LIST_FAIL';

export const ATT_MODIFY_PRESENCE_REQUEST = 'ATT_MODIFY_PRESENCE_REQUEST';
export const ATT_MODIFY_PRESENCE_SUCCESS = 'ATT_MODIFY_PRESENCE_SUCCESS';
export const ATT_MODIFY_PRESENCE_FAIL = 'ATT_MODIFY_PRESENCE_FAIL';


